import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { HttpClient } from "@angular/common/http";
import { AngularFireStorage } from "@angular/fire/storage";
import { CityService } from "./city.service";
import { VenueService } from "./venue.service";
import { Venue } from "../models/venue";
import { UserService } from "./user.service";
import { OrderService } from "./order.service";
import { DateService } from "./date.service";
import { AnalyticsService } from "./analytics.service";
import { City } from "../models";
import { RecipientService } from "./recipient.service";
@Injectable({
  providedIn: "root"
})
export class FirebaseService {
  public city: CityService;
  public user: UserService;
  public venue: VenueService;
  public analytics: AnalyticsService;
  public orders: OrderService;
  public recipients: RecipientService;

  constructor(
    public db: AngularFirestore,
    public httpClient: HttpClient,
    public storage: AngularFireStorage,
    public date: DateService
  ) {}

  init(uid: string, isOwner: boolean) {
    this.initRecipients();
    this.initUser();
    this.initVenue();
    this.user.getCurrentUser(uid);
    this.user.currentUser$.subscribe(user =>
      isOwner ? this.getAccessibleVenues() : null
    );
  }

  changeVenue(venue: Venue) {
    console.log(venue);
    this.venue.changeVenue(venue);
    this.initOrders(venue);
    this.initAnalytics(venue, this.venues);
  }

  async getAccessibleVenues() {
    await this.venue.getAccessibleVenues(this.user.cities, this.user.venues);
    this.changeVenue(this.venue.venues[0]);
  }

  get cities(): City[] {
    return this.city.cities;
  }

  get currentCity(): City {
    0;
    return this.city.current;
  }

  get isCitySelected(): Boolean {
    return this.city != null && this.city.current != null;
  }

  get venues(): Venue[] {
    return this.venue.venues;
  }

  get currentVenue(): Venue {
    return this.venue.current;
  }

  get isVenueSelected(): Boolean {
    return this.venue != null && this.currentVenue != null;
  }

  initCity = () => (this.city = new CityService(this.db, this.httpClient));

  initVenue = () => (this.venue = new VenueService(this.db));

  initUser = () => (this.user = new UserService(this.db, this.httpClient));

  initOrders(venue?: Venue) {
    this.orders = new OrderService(this.db, venue);
  }
  initRecipients = () =>
    (this.recipients = new RecipientService(this.db, this.httpClient));

  initAnalytics(venue?: Venue, venues?: Venue[]) {
    this.analytics = new AnalyticsService(this.db, venue);
    this.analytics.initializeAccessibleVenues(venues);
  }

  logout() {
    this.city = null;
    this.venue = null;
    this.orders = null;
    this.user = null;
    this.analytics = null;
  }

  public async saveImage(file, directory: string): Promise<string> {
    const id = Math.random()
      .toString(36)
      .substring(2);

    return this.storage.upload(directory + id, file).then(() => {
      return this.storage
        .ref(directory + id)
        .getDownloadURL()
        .toPromise<string>();
    });
  }

  public async sendPushNotificationRequest(message: {}): Promise<void> {
    await this.db.collection("PushNotificationRequests").add(message);
    return;
  }
}
